import type { ReactNode } from 'react'

interface FormFieldProps {
  label: string
  error?: string
  required?: boolean
  children: ReactNode
  hint?: string
}

export function FormField({ label, error, required, children, hint }: FormFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <label className="text-sm font-medium text-compumaq-textoSuave">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {children}
      {hint && !error && <p className="text-xs text-compumaq-textoSuave">{hint}</p>}
      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  )
}

export const inputClass =
  'w-full px-3 py-2 border border-compumaq-dourado/25 bg-compumaq-preto text-compumaq-texto rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-compumaq-dourado focus:border-transparent disabled:bg-compumaq-pretoSuave disabled:text-compumaq-textoSuave'

export const selectClass =
  'w-full px-3 py-2 border border-compumaq-dourado/25 bg-compumaq-preto text-compumaq-texto rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-compumaq-dourado focus:border-transparent'
